/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TenantService } from '@src/app/shared/tenant.service';

class LoginDay {
    dayName: string;
    loginDate: string;
    totalLogins: number;
    uniqueLogins: number;
}

class DeviceStat {
    deviceType: string;
    operatingSystem: string;
    uniqueUsers: number
}

class WhoseOnline {
    email: string;
    organisation: string;
    loggedIn: number;   // unix timestamp (seconds)
    logins: number;
    lastAction: number; // unix timestamp (seconds)
}

@Component({
    selector: 'app-stats',
    imports: [MatCardModule, DatePipe],
    templateUrl: './stats.component.html',
    styleUrl: './stats.component.scss'
})
export class StatsComponent {
    private http = inject(HttpClient);
    private baseUrl = TenantService.bareAjaxPath + 'stats/';
    private loginsUrl = this.baseUrl + 'logins';
    private devicesUrl = this.baseUrl + 'devices';
    private whoseOnlineUrl = this.baseUrl + 'whoseOnline';


    public loginDays: LoginDay[] = [];

    deviceStats: DeviceStat[] = [];
    deviceTypes: string[] = [];
    operatingSystems: string[] = [];
    tableData: Record<string, Record<string, number>> = {};

    whoseOnline: WhoseOnline[] = [];

    constructor() {
        this.http.get<LoginDay[]>(this.loginsUrl).subscribe( x => this.loginDays = x);
        this.http.get<WhoseOnline[]>(this.whoseOnlineUrl).subscribe( x => this.whoseOnline = x);

        this.http.get<DeviceStat[]>(this.devicesUrl).subscribe( x => {
            this.deviceStats = x;
            this.deviceTypes = Array.from(new Set(this.deviceStats.map(d => d.deviceType)));
            this.operatingSystems = Array.from(new Set(this.deviceStats.map(d => d.operatingSystem)));
            this.operatingSystems.forEach(os => {
                this.tableData[os] = {};
                this.deviceTypes.forEach(device => {
                const stat = this.deviceStats.find(d => d.deviceType === device && d.operatingSystem === os);
                this.tableData[os][device] = stat ? stat.uniqueUsers : 0;
                });
            });
        });
    }
}
